import React, { useState } from 'react';
import { ReactDrawer } from './Drawer';
import slugify from 'slugify';
import MenuItem from './MenuItem';

const MainNav = ({ mainMenu }) => {

  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <>
      <button className="Button component-toggle" data-style="solid icon base-black" onClick={() => setShowDrawer(!showDrawer)}>
        <svg className="icon icon--primary" height="1em" viewBox="0 0 20 20" width="1em">
          <use xlinkHref="#menu"></use>
        </svg>
        <span className="sr-only">Menu</span>
      </button>
      <ReactDrawer className="mainNav" showDrawer={showDrawer} setShowDrawer={setShowDrawer} position={'top'}>
        <div className="Drawer__header">
          <button class="Drawer__closeBtn Button" data-style="solid icon base-black" type="button" onClick={() => setShowDrawer(!showDrawer)}>
            <svg className="icon " height="1em" viewBox="0 0 20 20" width="1em">
              <use xlinkHref="#close"></use>
            </svg>
            <span className="sr-only">Close</span>
          </button>
        </div>
        <div className="drawer-scroller">
          <div className="Nav Nav--main" layout='vertical'>
            {mainMenu.map((link, index) => {
              return <MenuItem link={link} level={1} key={slugify(link.name).toLowerCase()} path={slugify(link.name).toLowerCase()}></MenuItem>;
            })}
          </div>
        </div>
      </ReactDrawer>
    </>
  );
};

export default MainNav